import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableAsRow = makeShortcode("PropsTableAsRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const PropsTablePassthroughPropsRow = makeShortcode("PropsTablePassthroughPropsRow");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Button} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default button`}</h3>
    <p>{`This is the default variant for the `}<inlineCode parentName="p">{`Button`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button>Default</Button>
`}</code></pre>
    <h3>{`Danger button`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`danger`}</inlineCode>{` variant of `}<inlineCode parentName="p">{`Button`}</inlineCode>{` is used to warn users about potentially destructive actions`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button variant="danger">Danger</Button>
`}</code></pre>
    <h3>{`Invisible button`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`invisible`}</inlineCode>{` variant of `}<inlineCode parentName="p">{`Button`}</inlineCode>{` indicates that the action is a low priority one.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button variant="invisible">Invisible</Button>
`}</code></pre>
    <h3>{`Different sized buttons`}</h3>
    <p><inlineCode parentName="p">{`Button`}</inlineCode>{` component supports three different sizes. `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Button size="small">Search</Button>
  <Button sx={{mt: 2}}>Search</Button>
  <Button sx={{mt: 2}} size="large">
    Search
  </Button>
</>
`}</code></pre>
    <h3>{`Appending an icon`}</h3>
    <p>{`We can place an icon inside the `}<inlineCode parentName="p">{`Button`}</inlineCode>{` in either the leading or the trailing position to enhance the visual context.
It is recommended to use an octicon here.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Button leadingVisual={SearchIcon}>Search</Button>
  <Button trailingVisual={SearchIcon} sx={{mt: 2}}>
    Search
  </Button>
  <Button leadingVisual={SearchIcon} trailingVisual={CheckIcon} sx={{mt: 2}}>
    Search
  </Button>
</>
`}</code></pre>
    <h3>{`Icon only button`}</h3>
    <p>{`A separate component called `}<inlineCode parentName="p">{`IconButton`}</inlineCode>{` is used if the action shows only an icon with no text. This button will remain square in shape.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<IconButton aria-label="Search" icon={SearchIcon} />
`}</code></pre>
    <h3>{`Different sized icon buttons`}</h3>
    <p><inlineCode parentName="p">{`IconButton`}</inlineCode>{` also supports the three different sizes. `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <IconButton aria-label="Search" size="small" icon={SearchIcon} />
  <IconButton aria-label="Search" icon={SearchIcon} sx={{ml: 2}} />
  <IconButton aria-label="Search" size="large" icon={SearchIcon} sx={{ml: 2}} />
</>
`}</code></pre>
    <h3>{`Button with counter`}</h3>
    <p>{`To show a count value as a trailing visual inside `}<inlineCode parentName="p">{`Button`}</inlineCode>{`, pass a value to the `}<inlineCode parentName="p">{`count`}</inlineCode>{` prop. The counter will match the `}<inlineCode parentName="p">{`variant`}</inlineCode>{` styles of the parent button.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button count="1">Watch</Button>
`}</code></pre>
    <h3>{`Block button`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`block`}</inlineCode>{` prop for full width buttons.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button block>Block</Button>
`}</code></pre>
    <h2>{`Props`}</h2>
    <p>{`Native `}<inlineCode parentName="p">{`<button>`}</inlineCode>{` HTML attributes are forwarded to the underlying React `}<inlineCode parentName="p">{`button`}</inlineCode>{` component and are not listed below.`}</p>
    <h3>{`Button`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" required type="React.ReactNode" description="Button description along with other components like Counter could be used here." mdxType="PropsTableRow" />
  <PropsTableRow name="variant" type="'default' | 'primary' | 'danger' | 'outline' | 'invisible'" description="Changes the look and feel of the button which is different for each variant" mdxType="PropsTableRow" />
  <PropsTableRow name="size" type="'small' | 'medium' | 'large'" description="Changes the size of the button component" mdxType="PropsTableRow" />
  <PropsTableRow name="block" type="boolean" description="Full width button fills the parent container" mdxType="PropsTableRow" />
  <PropsTableRow name="leadingVisual" type="Component" description="provide an octicon. It will be placed before the button text" mdxType="PropsTableRow" />
  <PropsTableRow name="trailingVisual" type="Component" description="provide an octicon. It will be placed after the button text" mdxType="PropsTableRow" />
  <PropsTableAsRow defaultElementType="button" mdxType="PropsTableAsRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
  <PropsTablePassthroughPropsRow elementName="button" passthroughPropsLink={<Link href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attributes" mdxType="Link">MDN</Link>} isPolymorphic mdxType="PropsTablePassthroughPropsRow" />
    </PropsTable>
    <h3>{`Button.Counter`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" required type="number" description="The counter value as a number" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ButtonGroup"
        }}>{`ButtonGroup`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      